var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g(_vm._b({staticClass:"old-form-input",class:{
    readonly: _vm.$attrs.readonly,
    'border-red-500 bg-red-100': !_vm.isValid
  }},'input',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }